<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ data?.selectedPasswordId ? 'Editar' : 'Nueva' }} Contraseña
</h2>

<mat-dialog-content class="modal-content">
  <form [formGroup]="passwordForm" class="space-y-4">

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Usuario</mat-label>
      <mat-select 
        formControlName="targetUserId" 
        placeholder="Seleccione un usuario asignado"
        (selectionChange)="filterAssignedUserByUserName(passwordForm.get('searchAssignedUser')?.value || '')">
        <mat-option>
          <ngx-mat-select-search 
            formControlName="searchAssignedUser"
            placeholderLabel="Buscar usuario asignado..."
            noEntriesFoundLabel="No se encontraron resultados"
            (ngModelChange)="filterAssignedUserByUserName($event)">
          </ngx-mat-select-search>
        </mat-option>

        <mat-option *ngFor="let assignedUser of filteredAssignedUserList" [value]="assignedUser.user_login__id">
          <div>
            <b class="f-9" *ngIf="getCode(assignedUser) as code">{{ code }}</b>
          </div>
          {{ assignedUser.user_login_username }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="passwordForm.get('targetUserId')?.hasError('required')">
        El usuario es obligatorio
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Motivo</mat-label>
      <input matInput formControlName="reason" placeholder="Motivo de la contraseña temporal" />
      <mat-error *ngIf="passwordForm.get('reason')?.hasError('required')">
        El motivo es obligatorio
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Duración (horas)</mat-label>
      <input matInput type="number" formControlName="durationInHours" min="1" max="8"/>
      <mat-error *ngIf="passwordForm.get('durationInHours')?.hasError('required')">
        La duración es obligatoria
      </mat-error>
      <mat-error *ngIf="passwordForm.get('durationInHours')?.hasError('min')">
        La duración debe ser al menos 1 hora
      </mat-error>
      <mat-error *ngIf="passwordForm.get('durationInHours')?.hasError('max')">
        La duración no puede ser mayor a 8 horas
      </mat-error>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!passwordForm.valid">
    Guardar
  </button>
</mat-dialog-actions>
